import React from 'react'
import { useChat } from '../chat-context'
import {
    ChatStatus,
    namedOperations,
    useUpdateChatMutation,
} from '~graphql/generated/graphql'
import ChatStatusSelect from '~components/chats/chats-list/chat-preview/status-select'

export default function ChatHeaderStatusSelect() {
    const { chat, refetchChatsList } = useChat()

    const [updateChat] = useUpdateChatMutation({
        refetchQueries: [
            namedOperations.Query.getChat,
            namedOperations.Query.queryClinicChatPreviews,
        ],
        onCompleted: () => {
            refetchChatsList()
        },
        awaitRefetchQueries: true,
    })

    async function handleSelectChatStatus(chatStatus: ChatStatus) {
        if (!Object.values(ChatStatus).includes(chatStatus)) {
            return
        }

        await updateChat({
            variables: {
                id: chat.id,
                data: { status: chatStatus },
            },
        })
    }

    return (
        <ChatStatusSelect
            chatStatus={chat.status}
            onSelectChatStatus={chatStatus =>
                handleSelectChatStatus(chatStatus as ChatStatus)
            }
        />
    )
}
